import { render, staticRenderFns } from "./BulkOutdatedRegister.vue?vue&type=template&id=e3dd9f06&"
import script from "./BulkOutdatedRegister.vue?vue&type=script&lang=js&"
export * from "./BulkOutdatedRegister.vue?vue&type=script&lang=js&"
import style0 from "./BulkOutdatedRegister.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports